import { render, staticRenderFns } from "./RoundDetailsV3.vue?vue&type=template&id=706f8a25&scoped=true&"
import script from "./RoundDetailsV3.vue?vue&type=script&lang=js&"
export * from "./RoundDetailsV3.vue?vue&type=script&lang=js&"
import style0 from "./RoundDetailsV3.vue?vue&type=style&index=0&id=706f8a25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f8a25",
  null
  
)

export default component.exports